import { render, staticRenderFns } from "./ContaDetail.vue?vue&type=template&id=080ea1aa&scoped=true"
import script from "./ContaDetail.vue?vue&type=script&lang=js"
export * from "./ContaDetail.vue?vue&type=script&lang=js"
import style0 from "./ContaDetail.vue?vue&type=style&index=0&id=080ea1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ea1aa",
  null
  
)

export default component.exports